"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerCms = void 0;
var SchedulerCms = /** @class */ (function () {
    function SchedulerCms() {
        this.schedulerAvailableAppointmentRadioLabel = 'I prefer the earliest available appointment';
        this.schedulerSpecificAppointmentRadioLabel = 'I prefer a specific day and timeframe';
        this.appointmentDayTimeEmailLabel = "Who do we contact on the day of installation? Be sure\n     someone who's at least 18 years old and able to act on your behalf is home throughout the entire visit.";
        this.preferredAppointmentDateTimeSelectionLabel = 'Select your preferred appointment date and timeframe.';
        this.scheduleAppointmentTitleLabel = 'Schedule your appointment';
        this.schedulePreferenceHeaderLabel = 'Schedule your appointment preference';
        this.firstAppointmentLabel = 'Here\'s our first available appointment.';
        this.availabilityTitleLabel = 'My availability';
        this.earliestInstallationAppointmentLabel = 'Installation appointment';
        this.updateDateTimeLabel = 'Update my date & time';
        this.addPreferenceLabel = 'Add my preference';
        this.appointmentTimeSelectionLabel = 'Technician\'s arrival window ';
        this.appointmentTimeSelectionLabelToolTip = "Your technician's arrival time is flexible. The time ranges listed\n     reflect the technician's arrival window and not the length of the installation.\n      Depending on services ordered, a standard installation takes an average of 4 hours\n       from the time your technician arrives.";
        this.installationDescription = "The first available appointment time has been preselected. Change the date and time in the boxes provided below.";
    }
    return SchedulerCms;
}());
exports.SchedulerCms = SchedulerCms;
//# sourceMappingURL=Scheduler.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/Scheduler/Scheduler.cms.js
// module id = 962
// module chunks = 8